var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wout-login",on:{"click":_vm.avancar}},[_c('div',{staticClass:"center"},[_c('div',{staticClass:"logo"},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.imgSrc),expression:"imgSrc"}],attrs:{"src":'data:' + _vm.imgTipo + ';base64,' + _vm.imgSrc,"alt":"Logo hotel","crossorigin":""}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }